<script lang="ts">
import { defineComponent, PropType, ref, watch, onMounted, nextTick } from 'vue'
import { inputTextDefaultProps } from '@/models/inputTextPartial'

export default defineComponent({
  name: 'InputDefault',

  props: {
    ...inputTextDefaultProps,

    /**
     * フォームの type 属性
     */
    type: {
      type: String as PropType<'text' | 'tel' | 'email' | 'number' | 'password'>,
      default: 'text'
    },
  },

  emits: ['update:modelValue', 'trim', 'focus', 'blur'],

  setup(props, { emit }) {
    const localValue = ref('')

    watch(() => props.modelValue, (newValue) => {
      if (localValue.value !== newValue) localValue.value = newValue
    })

    onMounted(() => {
      localValue.value = props.modelValue
    })

    const onBlur = async () => {
      if (props.hasTrim) {
        const _value = localValue.value
        localValue.value = localValue.value.trim() // 前後の空白を削除

        if (_value !== localValue.value) {
          emit('trim', localValue.value)
        }
      }

      await nextTick()
      emit('blur')
    }

    return {
      // data
      localValue,

      // methods
      onBlur,
    }
  }
})
</script>

<template>
  <input
    v-model="localValue"
    class="input"
    :type="type"
    :name="name ? name : undefined"
    :placeholder="placeholder"
    :disabled="isDisabled"
    :readonly="readonly"
    :required="required"
    :autocomplete="autocomplete"
    :pattern="pattern"
    :inputmode="inputmode"
    :maxlength="maxlength"
    :data-is-error="isError"
    @input="$emit('update:modelValue', localValue)"
    @focus="$emit('focus')"
    @blur="onBlur">
</template>
